import React from 'react'
import { Link } from 'react-router-dom'

import bg from '../../assets/images/bg.jpg'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogSidebar from '../../components/blog-sidebar'
import BlogComments from '../../components/blog-comments'
import BlogAbout from '../../components/blog-about'
import Footer from '../../components/footer'

export default function BlogStoryPost() {
  return (
    <>
    <Navbar/> 
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Story Post</h4>
                          <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Story Post</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 col-md-6">
                    <div className="card blog blog-primary border-0">
                        <div className="card-title mb-0">
                            <div className="section-title text-center">
                                <Link to="#" className="text-primary d-block h6 text-decoration-underline">Story</Link>
    
                                <span className="text-muted mb-0">20th June 2024</span>
                            </div>
                        </div>

                        <div className="blog-story py-5 mt-4 text-center bg-soft-primary rounded shadow">
                            <p className="fst-italic mb-0 fs-5">“ People think focus means saying yes to the thing you’ve got to focus on. But that’s not what it means at all building into the identity and culture. ”</p>
                        </div>
                        <BlogAbout/>
                    </div>
                    <BlogComments/>
                </div>
                <div className="col-lg-4 col-md-6">
                    <BlogSidebar/>
                </div>
            </div>
        </div>
    </section>
    <Shape/>
    <Footer/>   
    </>
  )
}
